import PropTypes from 'prop-types'
import { Component, createContext } from 'react'

const ServerResponseContext = createContext()
const ServerResponseConsumer = ServerResponseContext.Consumer

const withServerResponse = App => {
  return class extends Component {
    static displayName = 'withServerResponse(App)'

    static propTypes = {
      response: PropTypes.func,
    }

    static defaultProps = {
      response: () => null,
    }

    static async getInitialProps(context) {
      const { ctx } = context
      let props = {}

      if (App.getInitialProps) {
        props = await App.getInitialProps(context)
      }

      return {
        ...props,
        response: () => ctx.res,
      }
    }

    render() {
      const { response, ...props } = this.props

      if (process.browser) {
        return <App {...props} />
      }

      return (
        <ServerResponseContext.Provider value={response()}>
          <App {...props} />
        </ServerResponseContext.Provider>
      )
    }
  }
}

export { withServerResponse, ServerResponseConsumer }
